var _rect, _rect2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14.286,
    rx: 2,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gb_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14.286,
    rx: 2,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gb_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A17A7",
    d: "M0 0h20v14.286H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-.915-1.369L7.62 4.388v-5.34h4.762v5.34l8.535-5.757 1.065 1.58-6.748 4.55H20v4.763h-4.767l6.748 4.552-1.065 1.579-8.535-5.758v5.341H7.62v-5.34l-8.535 5.757-1.065-1.58 6.748-4.551H0V4.762h4.767L-1.98.21l1.065-1.579z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 4.523l9.047-5.952M14.295 9.784l8.11 5.466M5.72 4.507l-8.46-5.7M6.637 9.718l-9.377 6.218",
    stroke: "#DB1F35",
    strokeWidth: 0.667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.571h8.571v5.715h2.858V8.57H20V5.714h-8.571V0H8.57v5.714H0v2.857z",
    fill: "#E6273E"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjE0LjI4NTciIHJ4PSIyIiBmaWxsPSJ3aGl0ZSIvPgo8bWFzayBpZD0ibWFzazAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNSI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIxNC4yODU3IiByeD0iMiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIxNC4yODU3IiBmaWxsPSIjMEExN0E3Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNLTAuOTE1MDY4IC0xLjM2ODlMNy42MTk3NSA0LjM4NzkxVi0wLjk1MjM4NEgxMi4zODE3VjQuMzg4MTJMMjAuOTE2OCAtMS4zNjg4OEwyMS45ODE5IDAuMjEwMjM3TDE1LjIzMzggNC43NjE5SDIwLjAwMDdWOS41MjM4SDE1LjIzNEwyMS45ODIyIDE0LjA3NTVMMjAuOTE3IDE1LjY1NDZMMTIuMzgxNyA5Ljg5NzQyVjE1LjIzODFINy42MTk3NVY5Ljg5NzYyTC0wLjkxNTMzOSAxNS42NTQ2TC0xLjk4MDQ3IDE0LjA3NTVMNC43Njc2OSA5LjUyMzhIMC4wMDA3MDU3MTlWNC43NjE5SDQuNzY3OTRMLTEuOTgwMiAwLjIxMDIyM0wtMC45MTUwNjggLTEuMzY4OVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMy4zMzQgNC41MjI5OEwyMi4zODA3IC0xLjQyODU5IiBzdHJva2U9IiNEQjFGMzUiIHN0cm9rZS13aWR0aD0iMC42NjY2NjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuMjk0OSA5Ljc4Mzk0TDIyLjQwNDggMTUuMjUwMiIgc3Ryb2tlPSIjREIxRjM1IiBzdHJva2Utd2lkdGg9IjAuNjY2NjY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTUuNzE5MDYgNC41MDc0M0wtMi43NDAyMyAtMS4xOTM2IiBzdHJva2U9IiNEQjFGMzUiIHN0cm9rZS13aWR0aD0iMC42NjY2NjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi42MzY1NyA5LjcxNzc3TC0yLjc0MDIzIDE1LjkzNiIgc3Ryb2tlPSIjREIxRjM1IiBzdHJva2Utd2lkdGg9IjAuNjY2NjY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDguNTcxNDNIOC41NzE0M1YxNC4yODU3SDExLjQyODZWOC41NzE0M0gyMFY1LjcxNDI5SDExLjQyODZWMEg4LjU3MTQzVjUuNzE0MjlIMFY4LjU3MTQzWiIgZmlsbD0iI0U2MjczRSIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgGb as ReactComponent };